<template>
  <div class="allorder">
    <ld-navbar
      :left-arrow="navbarLeftShow"
      @click-right="filterShow = true"
      @click-left="back"
      order="allorder"
    >
      <span v-if=" (isYlslh5 && userInfo.empInfo.travelStats != 1) || AutoLogin">我的订单</span>
      <van-dropdown-menu v-else>
        <van-dropdown-item
          v-model="params.findScope"
          :options="options"
          @change="filterEnter"
        />
      </van-dropdown-menu>
      <template v-slot:right>
        <div
          class="van-tabbar-item__icon inline-block"
          style="line-height: 16px;"
        >
          <ld-icon
            slot="icon"
            style="color: #646566;"
            type="iconshaixuan"
            v-if="hasFilter"
          />
          <span v-else>
            <i class="iconfont icon-shaixuan1" style="font-size: 18px; color: #ff923e;"/>
            <div
              class="van-info van-info--dot"
            />
          </span>
        </div>
      </template>
    </ld-navbar>

    <!-- 列表 -->
    <van-tabs
      v-model="params.findType"
      animated
      line-height="2px"
      line-width="20px"
      sticky
      swipeable
      @click="ent($event)"
    >
      <van-tab
        :title="($t('A037','全部')+'('+totalCount.totalOrderCount+')')"
        :name="1"
      >
        <order-list
          :disabled="true"
          :list="allList"
          :page="allPage"
          @cancel="cancel"
          @pay="pay"
          @get-list="getList"
          @to-order-detail="toOrderDetail"
          @send-approval="sendApproval"
          @revert-approval="revertApproval"
        />
      </van-tab>

      <van-tab
        :title="($t('A101','未付款')+'('+totalCount.willPayCount+')')"
        :name="2"
      >
        <order-list
          :disabled="true"
          :list="topayList"
          :page="topayPage"
          @cancel="cancel"
          @pay="pay"
          @get-list="getList"
          @to-order-detail="toOrderDetail"
          @send-approval="sendApproval"
          @revert-approval="revertApproval"
        />
      </van-tab>

      <van-tab
        :title="$t('A102','待出行')+'('+totalCount.willTravelCount+')'"
        :name="3"
      >
        <order-list
          :disabled="true"
          :list="todoList"
          :page="todoPage"
          @cancel="cancel"
          @get-list="getList"
          @to-order-detail="toOrderDetail"
          @send-approval="sendApproval"
          @revert-approval="revertApproval"
        />
      </van-tab>

      <van-tab
        :title="$t('A103','退/改签')+'('+totalCount.refundChangeCount+')'"
        :name="4"
      >
        <order-list
          :disabled="true"
          :list="refundChangeList"
          :page="refundChangePage"
          @cancel="cancel"
          @pay="pay"
          @get-list="getList"
          @to-order-detail="toOrderDetail"
          @send-approval="sendApproval"
          @revert-approval="revertApproval"
        />
      </van-tab>
    </van-tabs>

    <!-- 筛选 -->
    <order-panel
      ref="filter"
      :filter.sync="params"
      :visibility.sync="filterShow"
      :autoLogin="AutoLogin"
      @selected="filterEnter"
    />

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="orderType"
      :order-id="orderId"
    /> -->

    <!-- 原因  -->
    <cancel-rason
      ref="cancelRason"
      @selected="chooseRason"
    />
  </div>
</template>

<script>
import 'Assets/font/download2/iconfont.css'
import {DropdownMenu, DropdownItem, Tab, Tabs, Toast} from 'vant'
import {getRelativeDate} from 'Utils/dateUtil'
import Bussiness from 'Utils/business'
import orderPanel from './components/orderPanel'
import orderList from './components/orderList'
import cancelRason from 'Views/Car/carOrder/components/cancelRason.vue'
import {mapActions, mapGetters} from 'vuex'
import ldNavbar from 'Common/ldNavbar'
import {initialOrderListParams} from '@/business/store/modules/app'
import defaultMixin from '@/business/mixins/default'
import {queryVipParameter} from 'Utils/publicApi'
import { isGat, toPayForGat } from 'Utils/gattools';
import {formatDate} from 'Utils/dateUtil'
// import ldPay from 'Components/ldPay/index.vue'
import { isTusi } from 'Utils/tusitools'

export default {
  name: 'Allorder',
  mixins: [defaultMixin],
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    orderPanel,
    orderList,
    // ldPay,
    cancelRason,
    ldNavbar
  },
  data() {
    return {
      navbarLeftShow: false,
      isExpire: {},
      li: true,
      creatime: '', // 开始时间
      daoTim: '',  // 倒计时时间
      msg: '',
      djs: '',
      time1: true,
      options: [
        {text: this.$t('A117', '我的订单'), value: '1'}, //A117
        {text: this.$t('A104', '全部订单'), value: '2'}  //A104
      ],
      totalCount: {
        totalOrderCount: 0,
        willPayCount: 0,
        willTravelCount: 0,
        refundChangeCount: 0,
      },
      params: initialOrderListParams(),
      allList: [],
      allPage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      topayList: [],
      topayPage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      todoList: [],
      todoPage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      refundChangeList: [],
      refundChangePage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      filterShow: false,
      orderType: '',
      orderId: '',
      orderInfo: {},
      time: '',
      creatimeno:''
    }
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.$store.commit('SET_ORDERLISTPARAMS', {
      dateStart: getRelativeDate(-7),
      dateEnd: getRelativeDate(0),
    })

    next()
  },
  mounted() {
    this.params.findType = Number(this.$route.query.findType)
    this.$nextTick(() => {
      let dropdown = document.querySelector('.van-dropdown-menu')
      dropdown && dropdown.classList.remove('van-hairline--top-bottom')
    })
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      orderListParams:'orderListParams',
      userInfo: 'userInfo'
    }),
    // 是否有选筛选条件
    hasFilter() {
      const defaultParmas = initialOrderListParams()
      defaultParmas.dateStart = formatDate(new Date(), -90).date
      if(isGat()){
        for (let key in defaultParmas) {
          if (key != 'findType' && key!='productType') { //关爱通只有一个机票所以不比较productType
            if (defaultParmas[key] != this.params[key]) {
              return false
            }
          }
        }
        return true
      }else{
        for (let key in defaultParmas) {
          if (key != 'findType') {
            if (defaultParmas[key] != this.params[key]) {
              return false
            }
          }
        }
        return true
      }
    },
    AutoLogin(){
      let AutoLogin= JSON.parse(localStorage.getItem('AutoLogin'))
      if ( AutoLogin!= null && AutoLogin.compId && (AutoLogin.compId == '84738d21f1904878873161fc4b88ecc8' || AutoLogin.compId == 'e44549fab7184ca392610ae516ec2857')) {//判断智通商户
        if (AutoLogin.corpId == '06a1ff73a3ec4202a607c7af124d81d8' || AutoLogin.corpId == 'acdc56476700470384447a675b0f9c84') {//判断智通企业
          if(this.userInfo.empInfo){
            return true
          }
        }
      }
      return false


    }
  },
  activated() {
    if(isTusi()) {
      this.navbarLeftShow = true
    }
    this.init()
  },
  created() {
    if(isTusi()) {
      this.navbarLeftShow = true
    }
    this.init()
    this.queryVipParameternavbar() //获取导航栏需要的操作
  },
  updated() {
    queryVipParameter('1221').then(res => {
      if (res.value1 == 0) {
        this.creatimeno=res.value1
      } else {
        this.allList.forEach((item) => {
          if (item.orderStatus == 3) {
            this.creatime = item.bookDate  // 下单开始的时间
            this.daoTim = res.value1  // 过期时间  15分钟 或者30分钟
            setInterval(this.countdown(item), 1000)   // 调用倒计时
            res.value1 // 根据value1返回的分钟数 页面展示倒计时
          }
          return false
        })
      }
    })
  },
  methods: {
    ...mapActions(['queryVipParameternavbar']),
    ent($event) {
      this.$router.replace({ path: '/allOrder', query: { findType: $event } });
      // this.getList()
    },
    async	init() {
      if (this.$route.query.findType) {
        this.$store.commit('SET_ORDERLISTPARAMS', {findType: this.$route.query.findType})
      }
      this.params.findType = this.$route.query.findType
      this.filterEnter()
    },
    filterEnter(filter) {
      if (this.time) {

      } else {
        this.time = setTimeout(async () => {
          let arr = ['', 'all', 'topay', 'todo', 'refundChange']
          arr.forEach(row => {
            row && (this[`${row}Page`].pageNum = 1, this[`${row}Page`].loading = true, this[`${row}Page`].finished = false)
            row && (this[`${row}List`] = [])
          })
          this.getTotalCount()
          this.getList()
          this.time = ''
        }, 500)
      }
    },
    getTotalCount() { // 条数
      return new Promise(async (resolve, reject) => {
        this.$api['common/totalCount'](this.params).then(res => {
          let cache = res.data || {}
          this.totalCount = res.data
          cache.refundChangeCount == 0 && (this.refundChangeList = [])
          cache.totalOrderCount == 0 && (this.allList = [])
          cache.willPayCount == 0 && (this.topayList = [])
          cache.willTravelCount == 0 && (this.todoList = [])
          resolve()
        }).catch(()=>{
          reject()
        })
      })

    },
    getList() { // 获取列表
      let arr = ['', 'all', 'topay', 'todo', 'refundChange']
      let page = this[`${arr[this.params.findType]}Page`]
      if (page.pageNum == 0) {
        page.pageNum = 1
      }
      this.$api['common/allOrderList']({
        ...this.params,
        pageNum: page.pageNum,
        count: page.count
      }).then(res => {
        if(this.params.findType==1 && !isTusi()){
          this.totalCount.totalOrderCount=res.data.total
        }
        page.loading = false
        const cache = res.data || {}
        // if(this.params.findType=='4'){//退改签
        //   this.totalCount.refundChangeCount=cache.total
        // }else if(this.params.findType=='3'){ //待出行
        //   this.totalCount.willTravelCount=cache.total
        // }else if(this.params.findType=='2'){//未付款
        //   this.totalCount.willPayCount=cache.total
        // }else if(this.params.findType=='1'){
        //   this.totalCount.totalOrderCount=cache.total
        // }
        if (cache.list) {
          //往返行程进行排序
          cache.list.forEach( item=> {
            if(item.orderRangeBeanList && item.orderRangeBeanList.length > 0){
              //进行排序
              item.orderRangeBeanList.sort((a,b)=>{
                const year = new Date().getFullYear(); // 使用当前年份
                const dateA = new Date(`${year}-${a.departTime.replace(' ', 'T')}`);
                const dateB = new Date(`${year}-${b.departTime.replace(' ', 'T')}`);
                return dateA - dateB;
              })
            }
          })

          if (cache.list.length < page.count) {
            page.finished = true
            // 仅支持全部订单生效
            if (this.params.findType == 1) {
              if (cache.list.length > page.count) {
                page.finished = true
              } else {
                page.finished = false
              }
            }
          } else {
            page.finished = false
          }
          if (cache.pageNum > 1) {
            this[`${arr[this.params.findType]}List`].push(...cache.list)
          } else {
            this[`${arr[this.params.findType]}List`] = cache.list
          }
        } else if (!cache.list && page.pageNum == 1) {
          this[`${arr[this.params.findType]}List`] = []
          page.finished = true
        } else {
          page.finished = true
        }
        if (cache.total == 0) {
          page.finished = true
        }
      }).catch(() => {
        page.error = true
      })
    },

    async isGoBtnDetail(item) {
      return await this.$api['tkStrategy/getTicketStatus']({
        orderId: item.id
      }).then(res => {
        return true
      }).catch(res => {
        this.$toast(res.errMsg)
        return false
      })
    },
    async toOrderDetail(item, type) { // 跳转订单详情
      this.$store.commit("SET_CPLX",item.cplx)
      if (item.cplx == '10901') {
        if (item.voyageType == 2) {
          if (this.$route.query.findType == 1 || this.$route.query.findType == 3 || this.$route.query.findType == 2) {
            if (type == 'applyChange') {//改签
              let result =  await this.isGoBtnDetail(item);
              console.log(result,'565656')
              if(!result){
                return;
              }
              this.$router.push('/tk/wfChangeApply?orderId=' + item.id + '&GoBack=true')
            } else if (type == 'applyRefund') {
              let result =  await this.isGoBtnDetail(item);
              if(!result){
                return;
              }
              this.$router.push('/tk/wfRefundApply?orderId=' + item.id + '&GoBack=true'+'&orderType='+item.orderType)
            } else {
              this.$router.push('/tk/wfOrderDetail?orderId=' + item.id + '&GoBack=true')
            }
          } else if (this.$route.query.findType == 4) {
            this.$router.push('/tk/wfRefundDetail?orderId=' + item.id + '&GoBack=true')
          }
        } else if (item.voyageType == 3) {
          if (this.$route.query.findType == 1 || this.$route.query.findType == 3 || this.$route.query.findType == 2) {
            if (type == 'applyChange') {
              this.$router.push('/tk/tkChangeApplylc?orderId=' + item.id + '&GoBack=true')
              // return this.$router.push({path: '/tk/tkChangeApplylc', query: {orderId: item.id, GoBack: true}})
            } else if (type == 'applyRefund') {//退票

              this.$router.push('/tk/tkRefundApplylc?orderId=' + item.id + '&GoBack=true')//单，往
            } else {
              this.$router.push('/tk/tkOrderDetaillc?orderId=' + item.id + '&GoBack=true')
            }
          } else if (this.$route.query.findType == 4) {
            if (item.voyageType == 3) {
              this.$router.push('/tk/tkRefundDetaillc?orderId=' + item.id + '&GoBack=true')
            } else if (item.voyageType == 2) {
              this.$router.push('/tk/wfRefundDetail?orderId=' + item.id + '&GoBack=true')
            } else {
            }
          }
        } else if (item.voyageType == 1) {
          if(type == 'applyChange' || type == 'applyRefund'){
            let result =  await this.isGoBtnDetail(item);
            if(!result){
              return;
            }
          }
          Bussiness.toOrderDetail(item, type)
        } else {
          this.$router.push('/t0?orderId=' + item.id)

        }
      } else {
        if(item.orderType == '11004'){
          this.$store.commit("tkInt/Refunditem",item)
        }
        Bussiness.toOrderDetail(item, type)
      }
    },
    sendApproval(detail) { // 送审
      Bussiness.ApprovalSend(detail)
    },
    async revertApproval(detail) { // 撤回送审
      await Bussiness.ApprovalRevert(detail)
      this.getList()
    },
    async cancel(item) { // 取消订单
      if (item.orderType == '11018' && !item.value) {
        this.orderInfo = item
        this.$api['carOrder/getCancelFee']({
          orderId: item.id
        }).then(res => {
          let cache = res.data || {}
          if (cache.khFine) {
            this.$dialog.confirm({
              title: '提示',
              message: '取消订单会产生罚金￥' + cache.khFine + '，是否继续取消订单？',
            }).then(() => {
              this.$refs.cancelRason.toggle()
            }).catch(() => {
              // on cancel
            })
          } else {
            this.$dialog.confirm({
              title: '提示',
              message: '是否取消订单',
            }).then(() => {
              this.$refs.cancelRason.toggle()
            }).catch(() => {
              // on cancel
            })
          }
        }).catch(res => {
          this.$toast(res.errMsg)
        })
        return
      }
      await Bussiness.toOrderCancel(item)
      this.getList()
    },
    isTimePassed(givenTime) {
      //收一个字符串类型的时间参数，返回一个布尔值，表示当前时间是否已经超过给定时间
      if (givenTime) {
        const givenDate = new Date(givenTime)
        const currentDate = new Date()
        return currentDate.getTime() > givenDate.getTime()
      } else {
        return false
      }
    },
    pay(item) { // 支付
      //火车票根据过期时间单独判断是否已经过期
      const trIsExpire = item.cplx === '10904' && this.isTimePassed(item.latePaymentTime)
      //除火车票外其他订单过期
      const otherIsExpire = item.cplx !== '10904' && this.isExpire[item.id]
      //  this.creatimeno!=0 这个判断不知准确不准确
      if ((otherIsExpire || trIsExpire) && this.creatimeno!=0) {
        Toast('订单已取消')
        this.getList()

      } else {
        this.getList()
        setTimeout(() => {
          // 关爱通支付
          if (isGat()) {
            return toPayForGat(item.id, item.orderType);
          }
          this.$router.push({path: '/pay/payment', query: {orderType: item.orderType, orderId: item.id}})
        }, 100)
      }

      if (this.msg = '') {
        this.time1 = false
      }
      this.orderType = item.orderType
      this.orderId = item.id

    },
    chooseRason(item) { // 选择取消原因
      let cache = Object.assign(this.orderInfo, item)
      this.cancel(cache)
    },
    back() {
      if(isTusi()) {
        AppChannel.postMessage('goBack');
        return false
      }
    }
  },
  watch:{
    'params.findType' () {
      this.filterEnter()
    }
  }
}
</script>

<style lang="less">
.allorder {
  .van-dropdown-menu__bar {
    box-shadow: none;
  }

  .van-tabs__line {
    z-index: 0;
  }
}
</style>
